import type { JSONContent } from '@tiptap/react';

/** Um parágrafo vazio: o que um modelo novo começa tendo. */
export const DOCUMENTO_VAZIO: JSONContent = { type: 'doc', content: [{ type: 'paragraph' }] };

/** Troca o conteúdo JSON em texto (como a API guarda) pelo objeto do editor. Inválido vira vazio. */
export const lerConteudo = (conteudoJson: string | null | undefined): JSONContent => {
    if (!conteudoJson) return DOCUMENTO_VAZIO;
    try {
        const obj = JSON.parse(conteudoJson);
        return obj && obj.type === 'doc' ? obj : DOCUMENTO_VAZIO;
    } catch {
        return DOCUMENTO_VAZIO;
    }
};
